import { render, staticRenderFns } from "./AccessInfoModal.vue?vue&type=template&id=2f3fda28&scoped=true&"
import script from "./AccessInfoModal.vue?vue&type=script&lang=js&"
export * from "./AccessInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./AccessInfoModal.vue?vue&type=style&index=0&id=2f3fda28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3fda28",
  null
  
)

export default component.exports